import React from 'react';
import {
	LineChart as LineChartRe,
	Line,
	XAxis,
	YAxis,
	ResponsiveContainer,
	Tooltip,
	BarChart as ReBarChart,
	Bar,
	Cell
} from 'recharts';
import styled from 'styled-components';
import { Text } from './Text';
import { useTheme } from '@mui/material/styles';
import numeral from 'numeral';
import _ from 'lodash';

export const LineChart = React.memo(({
	title,
	total,
	data,
	onClick,
	selectedSegment,
	yearTotal,
	rawTotal,
	average,
	height = 'auto',
	showTotal = true
}) => {
	const theme = useTheme();

	const handleOnClick = () => {
		if (onClick) {
			onClick(title);
		}
	};

	const getTotal = () => {
		if (yearTotal !== undefined && rawTotal !== undefined) {
			return `${total} - ${numeral(rawTotal / yearTotal * 100).format('0.00')}%`;
		}
		return total;
	};

	const getColor = () => {
		if (average) {
			if (rawTotal >= average + 5) {
				return theme.custom.positive;
			}
			if (rawTotal < average + 5 && rawTotal >= average - 5) {
				return theme.custom.neutral;
			}
			return theme.custom.negative;
		}
		return theme.custom.positive;
	};

	const color = getColor();
	const formatter = (value) => `$${numeral(value).format('0,00')}`;

	function numberWithCommas(x) {
		const numberWithCommas = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		return `$${numberWithCommas}`;
	}

	return (
		<ChartContainer style={{ height }}>
			<ChartTitle onClick={handleOnClick} variant="subtitle2" selected={title === selectedSegment} theme={theme}>
				{_.truncate(title)}
			</ChartTitle>
			<ResponsiveContainer height="100%" width="100%">
				<ReBarChart
					data={data}
					margin={{
						top: 5,
						right: 30,
						left: 20,
						bottom: 5
					}}
				>
					<Tooltip formatter={formatter} />
					<XAxis dataKey="title" />
					<YAxis tickFormatter={numberWithCommas} />
					<Bar dataKey="value" barSize={30} fill={color} />
				</ReBarChart>
			</ResponsiveContainer>
			{showTotal && (
				<ChartTitle style={{ color }} variant="subtitle1" theme={theme}>
					{getTotal()}
				</ChartTitle>
			)}
		</ChartContainer>
	);
});

const ChartTitle = styled(Text)`
  color: ${(props) => (props.selected ? props.theme.palette.primary.main : 'inherit')};
  cursor: pointer;
  margin-bottom: 10px !important;
  margin-left: 40px !important;
  :hover {
    text-decoration: underline;
  }
`;

const ChartContainer = styled.div`
	display: inline;
	text-align: center;
	width: 100%;
`;
